/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type MenuData = { menuId: number; items: Default<MenuItemData[]> };

export type MenuItemData = {
  label: string;
  url?: string;
  pageId?: number;
  contentType?: string;
  linkTarget?: string;
  isNonLinkingNode: boolean;
  children: Default<MenuItemData[]>;
};

export type NavigationItem = {
  id: string;
  path?: string;
  order?: number;
  external?: boolean;
  badge?: NavigationItemBadge;
  gate?: string;
  children: Default<NavigationItem[]>;
};

export type NavigationItemBadge = { count: number };

export type NavigationManifest = {
  portalInstanceType: PortalInstanceType;
  version: number;
  items: Default<NavigationItem[]>;
};

export type PortalInstanceType =
  | 'CUSTOMER'
  | 'BUYER'
  | 'BILLING'
  | 'REFERENCE'
  | 'CUSTOMER_SUCCESS'
  | 'DEAL_PLAN'
  | 'UNIVERSAL'
  | 'QUOTE'
  | 'TEAMWORK'
  | 'CUSTOM'
  | 'HOME_APP'
  | unhandledEnumCase;

export type PortalNavigationEntry = {
  portalInstanceId: number;
  displayName: string;
  portalInstanceType: PortalInstanceType;
  baseUrl: string;
  isCurrent: boolean;
  navigationManifest?: NavigationManifest;
  dynamicPortalObjects: Default<CrmObjectSummary[]>;
  hasMoreDynamicPortalObjects: Default<boolean>;
};

export type RequestedInstanceAccess = 'GRANTED' | 'DENIED' | unhandledEnumCase;

export const ConsentErrorTypename =
  'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export type ConsentError = {
  reason: ConsentErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.ConsentError';
} & { '@type'?: 'CONSENT' };

export const CustomerSuccessPortalErrorTypename =
  'com.hubspot.portals.platform.models.rpc.CustomerSuccessPortalError';
export const CustomerSuccessPortalErrorDiscriminant = 'CUSTOMER_SUCCESS_PORTAL';
export const CustomerSuccessPortalErrorDiscriminantKey = '@type';
export type CustomerSuccessPortalError = {
  reason: CustomerSuccessPortalErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.CustomerSuccessPortalError';
} & { '@type'?: 'CUSTOMER_SUCCESS_PORTAL' };

export const NotificationErrorTypename =
  'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export type NotificationError = {
  reason: NotificationErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.NotificationError';
} & { '@type'?: 'NOTIFICATION' };

export const PortalAuthErrorTypename =
  'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export type PortalAuthError = {
  reason: PortalAuthErrorReason;
  portalInstanceId?: number;
  denialReason?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
} & { '@type'?: 'AUTH' };

export const PortalPublicRpcErrorDiscriminantKey = '@type';
export type PortalPublicRpcError =
  | PortalAuthError
  | NotificationError
  | ConsentError
  | SettingsError
  | SupportPortalError
  | TranslationsError
  | TrackEventError
  | CustomerSuccessPortalError;

export const SettingsErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export type SettingsError = {
  reason: SettingsErrorReason;
  passwordErrors: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SettingsError';
} & { '@type'?: 'SETTINGS' };

export const SupportPortalErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export type SupportPortalError = {
  reason: SupportPortalErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
} & { '@type'?: 'SUPPORT_PORTAL' };

export const TrackEventErrorTypename =
  'com.hubspot.portals.platform.models.rpc.TrackEventError';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export type TrackEventError = {
  reason: TrackEventErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.TrackEventError';
} & { '@type'?: 'TRACK_EVENT' };

export type ConsentErrorReason =
  | 'CONSENT_LABELS_NOT_FOUND'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type CustomerSuccessPortalErrorReason =
  | 'ONBOARDING_PLAN_NOT_FOUND'
  | 'TASK_NOT_FOUND'
  | 'RESOURCE_NOT_FOUND'
  | 'INVALID_REQUEST'
  | unhandledEnumCase;

export type NotificationErrorReason =
  | 'NOTIFICATION_NOT_FOUND'
  | 'INVALID_NOTIFICATION_TYPE'
  | 'MISSING_PORTAL_ID'
  | 'INVALID_NOTIFICATION_NAME'
  | 'INVALID_TARGET'
  | 'PORTAL_INSTANCE_NOT_FOUND'
  | 'HUBSPOT_NOTIFICATION_SEND_FAILED'
  | unhandledEnumCase;

export type PortalAuthErrorReason =
  | 'AUTHENTICATION_FAILED'
  | 'ACCESS_DENIED'
  | 'UNEXPECTED_ERROR'
  | 'INVALID_PARAMETER_COUNT'
  | 'INVALID_PARAMETER_TYPES'
  | 'MISSING_ACCOUNT_ID'
  | 'MISSING_PORTAL_INSTANCE_ID'
  | 'MISSING_MEMBERSHIP_COOKIE'
  | 'EMPTY_MEMBERSHIP_COOKIE'
  | 'CSRF_ERROR'
  | 'MISSING_CRM_OBJECT_ID'
  | 'MISSING_CRM_OBJECT_ASSOCIATION'
  | 'FORM_NOT_FOUND'
  | 'WRONG_HUBLET'
  | unhandledEnumCase;

export type SettingsErrorReason =
  | 'MISSING_REQUIRED_FIELD'
  | 'CONTACT_NOT_FOUND'
  | 'FILE_TOO_LARGE'
  | 'UNSUPPORTED_FILE_TYPE'
  | 'WRONG_CURRENT_PASSWORD'
  | 'INVALID_PASSWORD'
  | 'SAME_PASSWORD'
  | 'PASSWORD_LEAKED'
  | 'PASSWORDS_DO_NOT_MATCH'
  | 'CURRENT_PASSWORD_REQUIRED'
  | 'INVALID_PREFERRED_LANGUAGE'
  | 'FIELD_TOO_LONG'
  | 'PROFILE_EDITING_DISABLED'
  | 'RATE_LIMITED'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type SupportPortalErrorReason =
  | 'SETTINGS_NOT_FOUND'
  | 'TICKET_NOT_FOUND'
  | 'THREAD_NOT_FOUND'
  | 'CONTACT_NOT_FOUND'
  | 'RESOURCE_NOT_FOUND'
  | 'INVALID_MESSAGE_PUBLISH'
  | 'INVALID_TICKET_ACTION'
  | 'INVALID_REQUEST'
  | unhandledEnumCase;

export type TrackEventErrorReason = 'EVENT_NOT_TRACKABLE' | unhandledEnumCase;

export type GetNavigationMenuRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type GetNavigationMenuResponse = {
  menuId?: number;
  menuData?: MenuData;
  isDomainSpecific: boolean;
};

export type GetPortalNavigationManifestsRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type GetPortalNavigationManifestsResponse = {
  manifest?: NavigationManifest;
};

export type GetPortalNavigationRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type GetPortalNavigationResponse = {
  portalNavigationEntries: Default<PortalNavigationEntry[]>;
  siteMenuData?: MenuData;
  requestedInstanceAccess: Default<RequestedInstanceAccess>;
  requestedInstanceDisplayName?: string;
};

export type CrmObjectSummary = {
  objectId: number;
  displayName: string;
  description?: string;
};

export const TranslationsErrorTypename =
  'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export type TranslationsError = {
  reason: TranslationsErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
} & { '@type'?: 'TRANSLATIONS' };

export type TranslationsErrorReason =
  | 'MISSING_LOCALE'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type GetNavigationManifestsRequestType =
  Requestify<GetPortalNavigationManifestsRequest>;
export type GetNavigationManifestsResponseType =
  GetPortalNavigationManifestsResponse;
export type GetNavigationManifestsErrorType = PortalAuthError & HubspotMetadata;
export const getNavigationManifestsRpc: ChirpAvroRpcDetails<
  GetNavigationManifestsRequestType,
  GetNavigationManifestsResponseType,
  GetNavigationManifestsErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getNavigationManifests',
  auth: 'external',
  fingerprint: '9iQqokfmRl-tVUOxTfJWK0WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPortalNavigationRequestType =
  Requestify<GetPortalNavigationRequest>;
export type GetPortalNavigationResponseType = GetPortalNavigationResponse;
export type GetPortalNavigationErrorType = PortalAuthError & HubspotMetadata;
export const getPortalNavigationRpc: ChirpAvroRpcDetails<
  GetPortalNavigationRequestType,
  GetPortalNavigationResponseType,
  GetPortalNavigationErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getPortalNavigation',
  auth: 'external',
  fingerprint: 'Ehvf7LXXS3fPWNqc5-u1TEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetNavigationMenuRequestType = Requestify<GetNavigationMenuRequest>;
export type GetNavigationMenuResponseType = GetNavigationMenuResponse;
export type GetNavigationMenuErrorType = PortalPublicRpcError & HubspotMetadata;
export const getNavigationMenuRpc: ChirpAvroRpcDetails<
  GetNavigationMenuRequestType,
  GetNavigationMenuResponseType,
  GetNavigationMenuErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getNavigationMenu',
  auth: 'external',
  fingerprint: 'PfMy5w0PVV6d9KLG3JsbUnOjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
